
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import Logo from "./Logo";
import {
  LayoutDashboard,
  Users,
  Bot,
  BrainCircuit,
  MessageCircle,
  Zap,
  Settings,
  LogOut,
  MessageSquare,
  Monitor,
  GitBranch
} from "lucide-react";
import { useToast } from "@/hooks/use-toast";

export const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { signOut, currentUser } = useAuth();
  const { toast } = useToast();

  console.log('Current user in Sidebar:', currentUser);
  console.log('Current location:', location.pathname);

  const handleLogout = async () => {
    try {
      console.log('Initiating logout process...');
      // Clear any stored data
      localStorage.removeItem('currentCompanyId');
      // Call the signOut function from useAuth
      await signOut();
      // No need to navigate here as signOut already does that
    } catch (error) {
      console.error('Error during logout:', error);
      toast({
        variant: "destructive",
        title: "Erro ao fazer logout",
        description: "Houve um problema ao desconectar. Por favor, tente novamente.",
      });
    }
  };

  const getMenuItems = () => {
    const baseItems = [
      { path: "/", label: "Dashboard", icon: <LayoutDashboard className="h-5 w-5" /> },
      { path: "/chatbot", label: "Chatbot", icon: <Bot className="h-5 w-5" /> },
      { path: "/ai-agents", label: "Agentes IA", icon: <BrainCircuit className="h-5 w-5" /> },
      { path: "/quick-messages", label: "Mensagens Rápidas", icon: <MessageCircle className="h-5 w-5" /> },
      { path: "/campaigns", label: "Campanhas", icon: <Zap className="h-5 w-5" /> },
      { path: "/automation-flow", label: "Automação", icon: <GitBranch className="h-5 w-5" /> },
      { path: "/integrations", label: "Integrações", icon: <MessageSquare className="h-5 w-5" /> },
      { path: "/settings", label: "Configurações", icon: <Settings className="h-5 w-5" /> },
    ];

    // Add Users item after Settings only for super_admin and admin
    if (currentUser?.type === 'super_admin' || currentUser?.type === 'admin') {
      console.log('Adding Users item to menu');
      baseItems.push({ path: "/users", label: "Usuários", icon: <Users className="h-5 w-5" /> });
    }

    // Add Monitoring at the end
    baseItems.push({ path: "/monitoring", label: "Monitoramento", icon: <Monitor className="h-5 w-5" /> });

    return baseItems;
  };

  const menuItems = getMenuItems();

  return (
    <div className="flex h-screen w-64 flex-col border-r bg-card px-3">
      <div className="flex h-14 items-center border-b px-3">
        <Logo />
      </div>
      <nav className="flex-1 space-y-2 py-4">
        {menuItems.map((item) => {
          console.log('Rendering menu item:', item.path, 'Current location:', location.pathname);
          return (
            <Link key={item.path} to={item.path}>
              <Button
                variant={location.pathname === item.path ? "secondary" : "ghost"}
                className="w-full justify-start gap-2"
              >
                {item.icon}
                <span>{item.label}</span>
              </Button>
            </Link>
          );
        })}
      </nav>
      <div className="border-t p-4">
        <Button
          variant="ghost"
          className="w-full justify-start text-red-500 hover:text-red-600 hover:bg-red-50"
          onClick={handleLogout}
        >
          <LogOut className="mr-2 h-5 w-5" />
          Sair
        </Button>
      </div>
    </div>
  );
};
